'use client';

import type { Sport } from '@sharpr/types';
import { usePricedSurfaceVersion } from '@/hooks/usePricedSurfaceVersion';

/**
 * Mount-only subscription to one sport's shared priced-surface version.
 * Odds routes and the MLB Projection Workspace mount it because either odds
 * writes or projection releases can change their current read models.
 */
export function PricedSurfaceVersionPoller({ sport }: { sport: Sport }) {
  usePricedSurfaceVersion(sport);
  return null;
}
